// Challenge Mode configuration.
// Player card reward pools come from the ChallengeL2_3 / ChallengeL4_5 / ChallengeL6_7_8
// columns in PlayersDataUnityImport.csv — each tier unlocks at a given level and stays
// available (for players not yet drafted) for the rest of the run.
// Action card pools come from "Before LN" columns in Action Cards.csv.

export const CHALLENGE_MAX_LEVEL = 8;
export const PLAYER_REWARD_DRAW = 8;  // how many player cards to show in the reward screen
export const PLAYER_REWARD_PICK = 4;  // how many the player can keep

// Player reward tiers: column unlocks once the player is about to start `unlockAtLevel`,
// and stays in the pool (minus already-drafted players) for every later draw too.
export const PLAYER_REWARD_TIERS = [
  { column: 'ChallengeL2_3',   unlockAtLevel: 2 },
  { column: 'ChallengeL4_5',   unlockAtLevel: 4 },
  { column: 'ChallengeL6_7_8', unlockAtLevel: 6 },
];

// Tier columns unlocked once the player is about to start `level`
export const activeTierColumns = (level) =>
  PLAYER_REWARD_TIERS.filter(t => t.unlockAtLevel <= level).map(t => t.column);

// CSV column names
export const actionInitialCol = (level) => `Before L${level}`;
// After winning level N, reward pool = "Before L(N+1)" cards not already owned
export const actionRewardCol  = (level) => `Before L${level + 1}`;

// Action card reward draft: every transition (Before L2..Before L8) shuffles 4 cards
// from that column (excluding ones already owned). L2 through L5 let you keep 2;
// L6 through L8 let you keep 3.
export const ACTION_REWARD_DRAW = 4;
export const actionRewardPick = (nextLevel) => (nextLevel >= 6 ? 3 : 2);

// CardType → SQUAD_GROUPS key mapping (Forwards group covers both FC and FW)
export const cardTypeToGroup = (cardType) =>
  cardType === 'ForwardCenter' || cardType === 'ForwardWide' ? 'Forwards' : cardType;

// Builds a "(Tendency Formation) Side" suffix from a Tournament.csv stage row, e.g.
// " (Attacking 3-5-2) Away". Returns '' for the neutral 4-4-2 (A)/(B) stages, which
// are only there for the backend tactic calculation and aren't meant to be shown.
export const formatChallengeMatchup = (stageRow) => {
  if (!stageRow) return '';
  const tendency = stageRow.Tendency?.trim();
  const formation = (stageRow['Tactic ']?.trim() || stageRow.Tactic?.trim() || '');
  const side = stageRow.Side?.trim();
  if (!tendency || !formation || !side) return '';
  if (/^4-4-2\s*\([AB]\)$/i.test(formation)) return '';

  return ` (${tendency} ${formation}) ${side}`;
};

export const SQUAD_GROUPS = [
  { key: 'Keeper',           label: 'Keepers',     short: 'GK', limit: 4  },
  { key: 'DefenderCenter',   label: 'Def. Center', short: 'DC', limit: 10 },
  { key: 'DefenderWide',     label: 'Def. Wide',   short: 'DW', limit: 6  },
  { key: 'MidfielderCenter', label: 'Mid. Center', short: 'MC', limit: 10 },
  { key: 'MidfielderWide',   label: 'Mid. Wide',   short: 'MW', limit: 6  },
  { key: 'Forwards',         label: 'Forwards',    short: 'FW', limit: 8  },
];
